import {
  CalendarMonth,
  FemaleOutlined,
  Language,
  LocationCityOutlined,
  PersonOutline,
} from "@mui/icons-material"; import React, { useEffect, useState } from "react";
import axios from "axios";
import "./EditPersonalDetail.css";
import "../Login/Login.css";
import { BASE_URL } from "../../BASE_URL";
import Modal from 'react-bootstrap/Modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../UserProfile/UserProfile.css'
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import latestCountries from "../../CountryStateCity.json"
import { useNavigate } from "react-router-dom";
import { CgRing } from "react-icons/cg";
import { MdPlace } from "react-icons/md";


const EditPersonalDetail = ({ updateBio }) => {

  const navigate = useNavigate();

  const [otherInfo, setOtherInfo] = useState([]);
  const [currentLocation, setCurrentLocation] = useState([]);
  const [hobbies, setHobbies] = useState([]);
  const [aassets, setAssets] = useState([])
  const [langaugeSpeak, setLangaugeSpeak] = useState([]);

  const [Yay, setYay] = useState("")

  const Call = async () => {
    const token = localStorage.getItem("saptvidhiUserToken");
    const res = await fetch(`${BASE_URL}/api/profile/userdetails`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const data = await res.json();
    setYay(data.data.UserDetails);
  };

  const checkProfile = async () => {
    try {
      const token = localStorage.getItem("saptvidhiUserToken");
      const res = await fetch(
        `${BASE_URL}/api/profile/checkProfile`,
        {
          method: "POST",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();

      if (data.data.user[0].user_other_infos) {
        const userInfo = data.data.user[0].user_other_infos;
        console.log('User Info:', userInfo); // Add this for debugging
        setOtherInfo(userInfo);
        setHobbies(userInfo.hobbies_name || []);
        setLangaugeSpeak(userInfo.languages_and_speak || []);
        setCurrentLocation(userInfo);
        setAssets(userInfo.assets || []);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const handleNavigateWithTab = (tabNumber) => {
    navigate("/edit-my-information", { state: { activeTab: tabNumber } });
  };

  useEffect(() => {
    Call();
    checkProfile();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-');
  };

  // Calculate if we should show the Other Details section
  const showOtherDetailsSection =
    (hobbies && hobbies.length > 0) ||
    (aassets && aassets.length > 0) ||
    (langaugeSpeak && langaugeSpeak.length > 0) ||
    (currentLocation && currentLocation.current_location_city) ||
    (otherInfo && Object.keys(otherInfo).length > 0) ||
    (Yay.settle_down && Yay.settle_down !== "");

  return (
    <div>
      <div className="r_login__wrapper1">


        <div>
          <div className="userprofile_section_header">
            <h3>Basic Details</h3>
            <button 
              className="edit_btn_profile" 
              style={{ cursor: "pointer" }} 
              onClick={() => handleNavigateWithTab("1")}
            >
              Edit
            </button>

          </div>
          <div>
            <div className="row">
              <div className="col-6 mb-2">
                <div className="userprofile_basic_details_content">
                  <FemaleOutlined />
                  <p className="mb-0" title="Gender">{Yay.gender}</p>
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="userprofile_basic_details_content">
                  <Language />
                  <p className="mb-0" title="Community">{Yay.community}</p>
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="userprofile_basic_details_content">
                  <CalendarMonth />
                  <p className="mb-0" title="Date Of Birth">
                    {formatDate(Yay.dob)}
                    {otherInfo && otherInfo.birth_time && (
                      <>
                        <span>({otherInfo.birth_time})</span>
                      </>
                    )}
                  </p>
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="userprofile_basic_details_content">
                  <PersonOutline />
                  <p className="mb-0" title="Religion">{Yay.religion}</p>
                </div>
              </div>
              {otherInfo && otherInfo.birth_place && (
                <div className="col-sm-6 col-12 mb-2">
                  <div className="userprofile_basic_details_content">
                    {/* <MdPlace style={{height:"30px", objectFit:"cover", width:"20px"}} /> */}
                    <img style={{height:"21px", objectFit:"cover", width:"20px"}} src="/birthPlace.png" alt="" />
                    <p className="mb-0" title="Birth Place">
                      {/* <span style={{ fontWeight: "600" }}>Birth Place : </span> */}
                      {typeof otherInfo.birth_place === 'string'
                        ? otherInfo.birth_place.replace(/[{}]/g, '')
                        : otherInfo.birth_place
                          ? `${otherInfo.birth_place.country || ''}, ${otherInfo.birth_place.state || ''}, ${otherInfo.birth_place.city || ''}`
                          : ''
                      }
                    </p>
                  </div>
                </div>
              )}
              <div className="col-sm-6 col-12 mb-2">
                <div className="userprofile_basic_details_content">
                  <LocationCityOutlined />
                  <p className="mb-0" title="City , State And Country">Live in {Yay.home_town} , {Yay.state} , {Yay.country} </p>
                </div>
              </div>
              <div className="col-6 mb-1">
                <div className="userprofile_basic_details_content">
                 <CgRing style={{
                      height: "25px",
                      width: "25px",
                      fontWeight: "600",
                      paddingRight: "0px",
                      objectFit:"cover"
                    }} />
                  <p className="mb-0" title="Marital Status">{Yay.marital_status}</p>
                </div>
              </div>


              

              {showOtherDetailsSection && (
                <div>
                  <div className="pb-2">
                <hr />
              </div>
                  <div className="userprofile_section_header">
                    <h3>Other Details</h3>
                    <button 
                      className="edit_btn_profile" 
                      style={{ cursor: "pointer" }} 
                      onClick={() => handleNavigateWithTab("2")}
                    >
                      Edit
                    </button>
                  </div>
                  {/* hobbies  */}

                  {hobbies && hobbies.length > 0 && (
                    <div className=" mb-2" style={{ overflowWrap: "anywhere" }}>
                      <div className="userprofile_basic_details_content user-profile-by-id-hobbies-display">
                        <h6 className="mb-0 width_sm_hobby">Hobbies :</h6>
                        <div style={{ display: "flex", flexWrap: "wrap", rowGap: "8px" }}>
                          {hobbies && hobbies.map((e) => {
                            return (
                              <>
                                <p className="mb-0 label_for_p" title="Hobbies">{e}</p>
                              </>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  )}

                  {aassets && aassets.length > 0 && (
                    <div className=" mb-2" style={{ overflowWrap: "anywhere" }}>
                      <div className="userprofile_basic_details_content">
                        <h6 className="mb-0 width_sm_hobby">Assets :</h6>
                        <div style={{ display: "flex", flexWrap: "wrap", rowGap: "8px" }}>
                          {aassets && aassets.map((e) => {
                            return (
                              <p className="mb-0 label_for_p" title="Assets">{e}</p>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  )}

                  {langaugeSpeak.length > 0 ? (
                    <div className=" mb-2">
                      <div className="userprofile_basic_details_content">
                        <h6 className="mb-0">Langauge Speak :</h6>
                        {langaugeSpeak.map((e) => (
                          <p className="mb-0 label_for_p" title="Language Speaks" key={e}>
                            {e}
                          </p>
                        ))}
                      </div>
                    </div>
                  ) : null}

                  {currentLocation && currentLocation.current_location_city && (
                    <div className="mb-2">
                      <div className="userprofile_basic_details_content">
                        <h6 className="mb-0">current location :</h6>
                        <p className="mb-0 label_for_p" title="current cit, state, country">{currentLocation.current_location_city},{currentLocation.current_location_state},{currentLocation.current_location_country}</p>
                      </div>
                    </div>
                  )}

                  {otherInfo.settling_abroad && Object.keys(otherInfo).length > 0 && (
                    <div className="mb-2">
                      <div className="userprofile_basic_details_content">
                        <h6 title="Settling In Abbroad">Settling In Abroad? : </h6>
                        <p className="mb-0 label_for_p" title="Settling In Abroad">
                          {otherInfo.settling_abroad}
                        </p>
                      </div>
                    </div>
                  )}

                  {Yay.settle_down ? (
                    <div className="mb-2">
                      <ToastContainer />
                      <div className="userprofile_basic_details_content">
                        <h6 className="mb-0" title="Planning to settle-down">Planning to settle-down in : </h6>
                        <p className="mb-0 label_for_p" title="Planning to settle-down">
                          {Yay.settle_down}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPersonalDetail;
